import { CalculateTourCo2 } from '@/domain/impact-calculate-tour/entities/calculate-tour-co2.entity';
import { translate } from '@/ui/i18n';
import { ProjectScoresDetailsData } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';

export function prepareProjectTourScoreDetailsDataCo2(
  calculateCo2: CalculateTourCo2,
): ProjectScoresDetailsData[] {
  return [
    {
      title: translate('ProjectsTour.GeneralCo2Quiz.Sections.CREATION'),
      value: calculateCo2.general.sections.CREATION.score,
      maxValue: NaN,
      refValue: NaN,
      viewMode: 'bar',
      detailsValues: [
        {
          name: translate('Co2.Sections.SCENOGRAPHY'),
          value:
            calculateCo2.general.sections.CREATION.categories.SCENOGRAPHY.score,
          unit: translate('Projects.teCO2'),
          topic: 'SCENOGRAPHY',
          type: 'co2',
          section: 'CREATION',
        },
        {
          name: translate(
            'ProjectsTour.GeneralCo2Quiz.Categories.TEAM_MOBILITY',
          ),
          value:
            calculateCo2.general.sections.CREATION.categories.TEAM_MOBILITY
              .score,
          unit: translate('Projects.teCO2'),
          topic: 'TEAM_MOBILITY',
          type: 'co2',
          section: 'CREATION',
        },
        {
          name: translate(
            'ProjectsTour.GeneralCo2Quiz.Categories.REPEATS_AND_MATERIAL',
          ),
          value:
            calculateCo2.general.sections.CREATION.categories
              .REPEATS_AND_MATERIAL.score,
          unit: translate('Projects.teCO2'),
          topic: 'REPEATS_AND_MATERIAL',
          type: 'co2',
          section: 'CREATION',
        },
      ],
    },
    {
      title: translate('ProjectsTour.GeneralCo2Quiz.Sections.MANAGEMENT'),
      value: calculateCo2.general.sections.MANAGEMENT.score,
      maxValue: NaN,
      refValue: NaN,
      viewMode: 'bar',
      detailsValues: [
        {
          name: translate(
            'ProjectsTour.GeneralCo2Quiz.Categories.TEAM_MOBILITY',
          ),
          value:
            calculateCo2.general.sections.MANAGEMENT.categories.TEAM_MOBILITY
              .score,
          unit: translate('Projects.teCO2'),
          topic: 'TEAM_MOBILITY',
          type: 'co2',
          section: 'MANAGEMENT',
        },
        {
          name: translate('Co2.Sections.CATERING'),
          value:
            calculateCo2.general.sections.MANAGEMENT.categories.CATERING.score,
          unit: translate('Projects.teCO2'),
          topic: 'CATERING',
          type: 'co2',
          section: 'MANAGEMENT',
        },
        {
          name: translate('ProjectsTour.GeneralCo2Quiz.Categories.OFFICE'),
          value:
            calculateCo2.general.sections.MANAGEMENT.categories.OFFICE.score,
          unit: translate('Projects.teCO2'),
          topic: 'OFFICE',
          type: 'co2',
          section: 'MANAGEMENT',
        },
      ],
    },
    {
      title: translate('ProjectsTour.GeneralCo2Quiz.Sections.COMMUNICATION'),
      value: calculateCo2.general.sections.COMMUNICATION.score,
      maxValue: NaN,
      refValue: NaN,
      viewMode: 'bar',
      detailsValues: [
        {
          name: translate(
            'ProjectsTour.GeneralCo2Quiz.Categories.VIDEO_AND_DIGITAL',
          ),
          value:
            calculateCo2.general.sections.COMMUNICATION.categories
              .VIDEO_AND_DIGITAL.score,
          unit: translate('Projects.teCO2'),
          topic: 'VIDEO_AND_DIGITAL',
          type: 'co2',
          section: 'COMMUNICATION',
        },
      ],
    },
  ];
}
